export default __webpack_public_path__ + "static/media/imagesmode.a5444a33.svg";